import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import CITIES from "../../utils/cities";
import CityPicker from "../../components/cityPicker/CityPicker";
import "./publish.css";
import useTour from "../../tour/useTour";
import publishSteps from "../../tour/steps/publishSteps";
import TourButton from "../../components/tourButton/TourButton";
import { hapticSuccess } from "../../services/haptics";

const IconCar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99ZM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16Zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5ZM5 11l1.5-4.5h11L19 11H5Z"/></svg>
);

const IconHand = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.998 2c-.552 0-1 .449-1 1v8l-1.862-.948c-.517-.264-1.152-.092-1.473.387l-.008.012c-.352.523-.18 1.235.362 1.544L13 14.5V20h5.5c.276 0 .5-.224.5-.5v-5.06c0-.155-.036-.309-.105-.447l-3.382-6.764A2 2 0 0 0 13.724 6H13V3c0-.551-.448-1-1-1Zm-6.5 12a.5.5 0 0 0-.5.5V19c0 .551.448 1 1 1h3v-6H6.498Z"/></svg>
);

const IconRoute = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.78 11.16l-1.42 1.42a7.462 7.462 0 0 1-1.02-2.68l1.98-.26c.14.82.48 1.58 1.02 2.18l-.56-.66ZM11 6l1.25-1.25c.41.52.71 1.13.89 1.79l1.92-.53c-.3-1.08-.82-2.09-1.56-2.93L12 1.5 9.37 4.13c-.74.84-1.26 1.85-1.56 2.93l1.92.53c.18-.66.48-1.27.89-1.79L11 6Zm9.54 6.26l-1.42-1.42c.54-.6.88-1.36 1.02-2.18l1.98.26c-.18.98-.56 1.91-1.14 2.72l-.44.62ZM20 13.5h-2c0 1.1-.45 2.1-1.17 2.83L12 21.16l-4.83-4.83A3.987 3.987 0 0 1 6 13.5H4c0 1.65.67 3.15 1.76 4.24L12 23.9l6.24-6.16C19.33 16.65 20 15.15 20 13.5Z"/></svg>
);

const IconClock = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7Z"/></svg>
);

const IconMoney = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.94s4.18 1.36 4.18 3.87c0 1.92-1.37 3.07-3.12 3.37Z"/></svg>
);

const IconSeat = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4 18v3h3v-3h10v3h3v-6H4v3Zm15-8h3v3h-3v-3ZM2 10h3v3H2v-3Zm15.5 0c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1ZM6 10.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5ZM9 7c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v6H9V7Z"/></svg>
);

const IconSend = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"/></svg>
);

const Publish = ( { isLoggedIn, loginUser, onLogout } ) => {
  const [cities, setCities] = useState(["Lahore", "Islamabad", "Rawalpindi", "Karachi", "Peshawar"]);
  const [finderFormData, setFinderFormData] = useState({departure: cities[0], arrival: cities[1], route:"", estimatedDate: formatDate(new Date()) });
  const [posterFormData, setPosterFormData] = useState({departure: cities[0], arrival: cities[1], route:"", estimatedDate: formatDate(new Date()), totalSeats: 1, fare: { amount: "500", currency: "PKR" }, vehicle: { model: "", color: "", plateNumber: "" } });
  const [finderError, setFinderError] = useState("");
  const [posterError, setPosterError] = useState("");
  const [isPosterMode, setIsPosterMode] = useState(false);
  const [editRideId, setEditRideId] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { startTour } = useTour("publish", publishSteps, true);

  useEffect(()=> {
    setCities(CITIES);
    setFinderFormData((prevFormData) => ({ ...prevFormData, departure: CITIES[0], arrival: CITIES[1] }));
    setPosterFormData((prevFormData) => ({ ...prevFormData, departure: CITIES[0], arrival: CITIES[1], fare: { amount: "500", currency: "PKR" } }));
  }, [loginUser]);

  useEffect(() => {
    const editId = searchParams.get("edit");
    const repeatId = searchParams.get("repeat");
    const sourceId = editId || repeatId;
    if (sourceId) {
      if (editId) setEditRideId(editId);
      setIsPosterMode(true);
      axios.get(`/api/v1/ride/getOneRide/${sourceId}`).then((res) => {
        const r = res.data.rideWithPosterPassengerInfo;
        // For repeat: use tomorrow same time; for edit: use existing date
        const etd = repeatId
          ? formatDate(new Date(Date.now() + 24 * 60 * 60 * 1000))
          : (r.estimatedDate ? formatDate(new Date(r.estimatedDate)) : formatDate(new Date()));
        // For repeat: restore original seat count (available + booked passengers)
        const bookedCount = (r.passengerList || []).filter(p => !p.isBookingCancelled).length;
        const originalSeats = repeatId ? (r.totalSeats + bookedCount) : r.totalSeats;
        setPosterFormData({
          departure: r.departure || CITIES[0],
          arrival: r.arrival || CITIES[1],
          route: r.route === "nil" ? "" : (r.route || ""),
          estimatedDate: etd,
          totalSeats: originalSeats ?? 1,
          fare: r.fare || { amount: "500", currency: "PKR" },
          vehicle: r.vehicle || { model: "", color: "", plateNumber: "" },
        });
      }).catch((err) => {
        console.error("Failed to load ride for editing:", err);
        setEditRideId(null);
        setPosterError(err.response?.data?.message || "Failed to load ride details. Please try again.");
      });
    }
  }, [searchParams]);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/');
    }
  }, [isLoggedIn, navigate]);

  // Helper function to format the date
  function formatDate(date) {
    const pad = (num) => String(num).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours()+1)}:${pad(date.getMinutes())}`;
  }

  const handleFinderChange = (event) => {
    setFinderError("");
    const { name, value } = event.target;
    setFinderFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleRequestSubmit = async (event) => {
    event.preventDefault();
    setFinderError("");

    try {
      await axios.post('/api/v1/ride/createRequest/', finderFormData);
      hapticSuccess();
      navigate('/listing');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        onLogout();
        navigate('/login');
      } else {
        setFinderError(error.response.data.message);
      }
    }
  };

  const handlePosterClick = () => {
    setIsPosterMode(true);
    setFinderError("");
  };

  const handleFinderClick = () => {
    setIsPosterMode(false);
    setPosterError("");
  };

  const handlePosterChange = (event) => {
    setPosterError('');
    const { name, value } = event.target;
    setPosterFormData((prevData) => {
      if (name === 'amount') {
        return {
          ...prevData,
          fare: {
            ...prevData.fare,
            amount: value ? parseInt(value) : ''
          }
        };
      } else if (name === 'vehicleModel' || name === 'vehicleColor' || name === 'vehiclePlateNumber') {
        const vehicleField = name.replace('vehicle', '').charAt(0).toLowerCase() + name.replace('vehicle', '').slice(1);
        return {
          ...prevData,
          vehicle: {
            ...prevData.vehicle,
            [vehicleField]: value
          }
        };
      } else {
        return {
          ...prevData,
          [name]: value
        };
      }
    });
  };

  const handlePosterSubmit = async (event) => {
    event.preventDefault();
    setPosterError("");

    try {
      if (editRideId) {
        await axios.post(`/api/v1/ride/editRide/${editRideId}?_method=PUT`, posterFormData);
        hapticSuccess();
        navigate(`/ride/${editRideId}`);
      } else {
        await axios.post(`/api/v1/ride/createRide`, posterFormData);
        hapticSuccess();
        navigate('/listing');
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        onLogout();
        navigate('/login');
      } else {
        setPosterError(error.response.data.message);
      }
    }
  };

  const handlePosterDatePart = (event) => {
    const { name, value } = event.target;
    setPosterError('');
    setPosterFormData((prev) => {
      const [date, time] = prev.estimatedDate.split('T');
      const newDate = name === 'estDate' ? `${value}T${time}` : `${date}T${value}`;
      return { ...prev, estimatedDate: newDate };
    });
  };

  const handleFinderDatePart = (event) => {
    const { name, value } = event.target;
    setFinderError('');
    setFinderFormData((prev) => {
      const [date, time] = prev.estimatedDate.split('T');
      const newDate = name === 'estDate' ? `${value}T${time}` : `${date}T${value}`;
      return { ...prev, estimatedDate: newDate };
    });
  };

  const isSuccessMessage = (msg) => {
    if (!msg) return false;
    const lower = msg.toLowerCase();
    return lower.includes("success") || lower.includes("created") || lower.includes("posted");
  };

  const renderOfferForm = () => (
    <form className="sr-publish__form" onSubmit={handlePosterSubmit}>

      {/* Route */}
      <div className="sr-publish__section" data-tour="publish-route">
        <div className="sr-publish__section-label">
          <IconRoute /> Route
        </div>
        <div className="sr-publish__route-pair">
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--from" />
            <CityPicker cities={cities} value={posterFormData.departure} onChange={(city) => setPosterFormData((prev) => ({ ...prev, departure: city }))} label="From" />
          </div>
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--to" />
            <CityPicker cities={cities} value={posterFormData.arrival} onChange={(city) => setPosterFormData((prev) => ({ ...prev, arrival: city }))} label="To" />
          </div>
        </div>
      </div>

      {/* Via Route */}
      <div className="sr-publish__section">
        <div className="sr-publish__field-card">
          <div className="sr-publish__field-row">
            <IconRoute />
            <input type="text" name="route" value={posterFormData.route} onChange={handlePosterChange} placeholder="Via — e.g. Highway M-1"/>
          </div>
        </div>
      </div>

      {/* Date & Time */}
      <div className="sr-publish__section" data-tour="publish-datetime">
        <div className="sr-publish__section-label">
          <IconClock /> Departure
        </div>
        <div className="sr-publish__inline-pair">
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="date" name="estDate" value={posterFormData.estimatedDate.split('T')[0]} onChange={handlePosterDatePart}/>
            </div>
          </div>
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="time" name="estTime" value={posterFormData.estimatedDate.split('T')[1]} onChange={handlePosterDatePart}/>
            </div>
          </div>
        </div>
      </div>

      {/* Fare & Seats */}
      <div className="sr-publish__section" data-tour="publish-pricing">
        <div className="sr-publish__section-label">
          <IconMoney /> Pricing & Seats
        </div>
        <div className="sr-publish__inline-pair">
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <IconMoney />
              <input type="number" name="amount" min={1} value={posterFormData.fare.amount} onChange={handlePosterChange} placeholder="Fare (PKR)"/>
            </div>
          </div>
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <IconSeat />
              <select name="totalSeats" value={posterFormData.totalSeats} onChange={(e) => setPosterFormData((prev) => ({ ...prev, totalSeats: Number(e.target.value) }))}>
                <option value={1}>1 Seat</option>
                <option value={2}>2 Seats</option>
                <option value={3}>3 Seats</option>
                <option value={4}>4 Seats</option>
                <option value={5}>5 Seats</option>
                <option value={6}>6 Seats</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Vehicle Details */}
      <div className="sr-publish__section" data-tour="publish-vehicle">
        <div className="sr-publish__section-label">
          <IconSeat /> Vehicle (optional)
        </div>
        <div className="sr-publish__field-card">
          <div className="sr-publish__field-row">
            <input type="text" name="vehicleModel" value={posterFormData.vehicle.model} onChange={handlePosterChange} placeholder="e.g. Toyota Corolla"/>
          </div>
        </div>
      </div>

      {posterError && (
        <div className={`sr-publish__error ${isSuccessMessage(posterError) ? 'sr-publish__error--success' : 'sr-publish__error--fail'}`}>
          {posterError}
        </div>
      )}

      <button type="submit" className="sr-publish__submit sr-publish__submit--offer" data-tour="publish-submit">
        <IconSend /> {editRideId ? "Save Changes" : "Offer Ride"}
      </button>
    </form>
  );

  const renderRequestForm = () => (
    <form className="sr-publish__form" onSubmit={handleRequestSubmit}>

      {/* Route */}
      <div className="sr-publish__section">
        <div className="sr-publish__section-label">
          <IconRoute /> Route
        </div>
        <div className="sr-publish__route-pair">
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--from" />
            <CityPicker cities={cities} value={finderFormData.departure} onChange={(city) => setFinderFormData((prev) => ({ ...prev, departure: city }))} label="From" />
          </div>
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--to" />
            <CityPicker cities={cities} value={finderFormData.arrival} onChange={(city) => setFinderFormData((prev) => ({ ...prev, arrival: city }))} label="To" />
          </div>
        </div>
      </div>

      {/* Via Route */}
      <div className="sr-publish__section">
        <div className="sr-publish__field-card">
          <div className="sr-publish__field-row">
            <IconRoute />
            <input type="text" name="route" value={finderFormData.route} onChange={handleFinderChange} placeholder="Via — e.g. Highway M-1"/>
          </div>
        </div>
      </div>

      {/* Date & Time */}
      <div className="sr-publish__section">
        <div className="sr-publish__section-label">
          <IconClock /> Departure
        </div>
        <div className="sr-publish__inline-pair">
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="date" name="estDate" value={finderFormData.estimatedDate.split('T')[0]} onChange={handleFinderDatePart}/>
            </div>
          </div>
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="time" name="estTime" value={finderFormData.estimatedDate.split('T')[1]} onChange={handleFinderDatePart}/>
            </div>
          </div>
        </div>
      </div>

      {finderError && (
        <div className={`sr-publish__error ${isSuccessMessage(finderError) ? 'sr-publish__error--success' : 'sr-publish__error--fail'}`}>
          {finderError}
        </div>
      )}

      <button type="submit" className="sr-publish__submit sr-publish__submit--request">
        <IconHand /> Request Ride
      </button>
    </form>
  );

  return (
    <div className="sr-publish">
      {/* ── Dark top section with rounded bottom ── */}
      <div className="sr-publish__top">
        <div className="sr-publish__top-content">
          <div className="sr-publish__header">
            <h1 className="sr-publish__title">
              {editRideId ? "Edit Ride" : searchParams.get("repeat") ? "Repeat Ride" : isPosterMode ? "Request a Ride" : "Offer a Ride"}
            </h1>
            <p className="sr-publish__subtitle">
              {editRideId
                ? "Update your ride details"
                : searchParams.get("repeat")
                  ? "Create a new ride with the same details"
                  : isPosterMode
                  ? "I need a seat and would love to join you"
                  : "I'm traveling and have seats available"
              }
            </p>
          </div>

        </div>
      </div>

      {/* ── White body section ── */}
      <div className="sr-publish__body">
        {/* Mode Toggle */}
        {!editRideId && !searchParams.get("repeat") && (
          <div className="sr-publish__toggle" data-tour="publish-toggle">
            <input type="radio" name="mode" id="mode-offer" checked={!isPosterMode} onChange={handleFinderClick} />
            <input type="radio" name="mode" id="mode-request" checked={isPosterMode} onChange={handlePosterClick} />
            <label htmlFor="mode-offer" className={`sr-publish__toggle-label ${!isPosterMode ? 'sr-publish__toggle-label--active' : ''}`} onClick={handleFinderClick}>
              <IconCar /> Offer
            </label>
            <label htmlFor="mode-request" className={`sr-publish__toggle-label ${isPosterMode ? 'sr-publish__toggle-label--active' : ''}`} onClick={handlePosterClick}>
              <IconHand /> Request
            </label>
            <div className={`sr-publish__toggle-slider ${isPosterMode ? 'sr-publish__toggle-slider--right' : ''}`} />
          </div>
        )}
        {(editRideId || searchParams.get("repeat")) ? renderOfferForm() : isPosterMode ? renderRequestForm() : renderOfferForm()}
      </div>
      <TourButton onClick={startTour} />
    </div>
  );
}

export default Publish;
